<template>

  <div>
    <div class="card">
      <h3>{{ headline }}</h3>
      <!-- Abschnitte statt eines Strings, damit die Anrufzeit fett sein kann,
           ohne v-html zu benutzen. Siehe buildTextParts in CallEta.js. -->
      <p class="confirm-text"><template v-for="(part, idx) in bodyParts" :key="idx"><strong
          v-if="part.bold">{{ part.text }}</strong><template v-else>{{ part.text }}</template></template></p>
      <!-- Ads -->
      <div v-if="stepConfig.cross_selling === true" class="ads">

    <h4 class="cross-selling-title" v-if="stepConfig.cross_selling_options && stepConfig.cross_selling_options.title">{{stepConfig.cross_selling_options.title}}</h4>
    <component v-if="stepConfig.cross_selling_options.ad_type" :cross_selling_options="stepConfig.cross_selling_options" :config="config" :is="stepConfig.cross_selling_options.ad_type"></component>

    </div>
      </div>
    <iframe v-if="shouldEmbedIframe" :src="iframeSrc" style="position:absolute;left:-9999px"></iframe>
  </div>

</template>

<script>
import Tracking from "../../helpers/Tracking.js";
import AdImageBox from "../ads/AdImageBox.vue";
import { callEtaText, buildTextParts, FALLBACK_TEXT } from "../../helpers/CallEta.js";
import ServerTime from "../../helpers/ServerTime.js";

const HEADLINE = "📞 Fast geschafft – bitte nehmen Sie unseren Anruf an";

// Greift für alle Verticals, die kein eigenes 'text' im AfterSave-Step setzen
// (das ist die Mehrheit). {{ANRUFZEIT}} wird zur Laufzeit ersetzt.
const DEFAULT_TEXT =
    "Ein Kundenberater ruft Sie {{ANRUFZEIT}} an, um Ihre Angaben kurz mit Ihnen durchzugehen. " +
    "Ohne dieses Gespräch können wir Ihre Anfrage nicht bearbeiten – es dauert etwa 2 Minuten, " +
    "ist kostenlos und unverbindlich. Am Telefon wird nichts abgeschlossen.";

// Wie oft die Anrufzeit neu berechnet wird, falls der Tab offen bleibt.
const ETA_REFRESH_MS = 60000;

export default {
    name: "SearchStep",
    props: ["isActive", "config", "stepConfig", "data"],
    emits: ["nextStep"],
    computed: {
        headline() {
            return HEADLINE;
        },
        bodyParts() {
            const template = (this.stepConfig && this.stepConfig.text) || DEFAULT_TEXT;
            return buildTextParts(template, this.etaText);
        },
    },
    watch: {
        isActive(newVal) {
          if (newVal) {
            this.updateEta();
            this.startEtaRefresh();

            if(this.config && this.config.type === 'IMMOBILIE' && this?.data?.verkaufszeitpunkt === 'Momentan nicht'){
              return;
            }

            Tracking.sendPageView(this.config, this.stepConfig);

            if (typeof UC_UI !== 'undefined' ) {
              if (UC_UI.getServicesBaseInfo().filter(data => data.consent.status === true && data.name === 'Google AdWords Conversion').length > 0) {
                this.loadNativendo(this.config);
              }
            }

            // Parse the query parameters from the URL
            const urlParams = new URLSearchParams(window.location.search);
            const utmSource = urlParams.get('utm_source');
            const token = urlParams.get('token');

            // Check if the conditions are met
            if (utmSource === 'cf' && token) {
              this.shouldEmbedIframe = true;
              this.iframeSrc = `https://cfpixl.blue/cf394-ty?token=${token}`;
            }
          } else {
            this.shouldEmbedIframe = false;
            this.stopEtaRefresh();
          }
        }
    },
    data: () => {
        return {
            val: null,
          shouldEmbedIframe: false,
          iframeSrc: '',
          etaText: FALLBACK_TEXT,
          etaTimer: null,
        };
    },
    mounted() {
      // Einmal beim Mount rechnen, damit nie ein Platzhalter oder der Fallback
      // stehen bleibt, falls dieser Step schon aktiv ist (der isActive-Watcher
      // feuert ohne immediate:true nicht für den initialen Wert).
      // Bei Aktivierung wird erneut gerechnet — dann liegt die Serverzeit vor.
      this.updateEta();
      if (this.isActive) {
        this.startEtaRefresh();
      }
    },
    beforeUnmount() {
      this.stopEtaRefresh();
    },
    methods: {
      /**
       * Anrufzeit berechnen. Läuft zweimal: einmal in mounted() (Client-Zeit)
       * und erneut bei Aktivierung des Steps — dann liegt die Serverzeit aus
       * dem Lead-POST vor und verdrängt die Client-Zeit.
       * Wirft nie: callEtaText fängt intern alles ab und liefert "in Kürze".
       */
      updateEta(){
        this.etaText = callEtaText(ServerTime.now(), this.stepConfig && this.stepConfig.call_eta);
      },

      startEtaRefresh(){
        this.stopEtaRefresh();
        // Damit der Text nicht veraltet, wenn jemand den Tab offen stehen lässt.
        this.etaTimer = window.setInterval(this.updateEta, ETA_REFRESH_MS);
      },

      stopEtaRefresh(){
        if (this.etaTimer) {
          window.clearInterval(this.etaTimer);
          this.etaTimer = null;
        }
      },

      loadNativendo(config){
        if(config.nativendoId) {
          let script = document.createElement('script');
          script.src = "https://t.nativendo.de/cds/track/event/s/" + config.nativendoId + "?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_371}";

          let noscript = document.createElement('noscript');
          let img = document.createElement('img');
          img.src = "https://t.nativendo.de/cds/track/event/s/" + config.nativendoId + "/pxl/1?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_371}";
          img.alt = "";
          img.style = "position:absolute;visibility:hidden;width:1px;height:1px;";
          noscript.appendChild(img);

          document.body.appendChild(script);
          document.body.appendChild(noscript);
        }

      }
    },
    components: { AdImageBox }
}
</script>

<style scoped>

h3 {
  margin-top: 0;
}

h4 {
  text-align: center;
}

.card {
  width: 800px;
  max-width: 100%;
  box-sizing: border-box;
}

.card h3 {
  font-size: 25px;
  text-align: center;
  font-weight: bold;
}

.card__row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px;
}

p {
  line-height: 1.5em;
}

.cross-selling-title {
  font-size: 1.2em;
  margin-top: 70px;
  line-height: 1.5em;
}

.confirm-text {
  text-align: center;
}

@media (max-width: 600px) {
  .card h3 {
    font-size: 20px;
  }
}

</style>
